import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
// import Button from '../../components/Button/Button';
// import Input from '../../components/Input/Input';
import './subscriptiontype.scss';
import '../MyTasksList/mytaskslist.scss';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import Modal from '../../components/Modal/Modal';
import base from '../../apis';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';

function SubscriptionType() {
  //allow only bpo-farm-agent, premier-agent-website,deal-analyzer routes

  const allowed = ['bpo-farm', 'premier-agent-website', 'deal-analyzer'];
  const { type } = useParams();
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const snr_marketer_id = useSelector((state) => state.auth?.marketerDetails?.id);
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [recent, setRecent] = useState([]);
  const [selectedSub, setSelectedSub] = useState(null);

  const title = type
    .split('-')
    .map((item) => item[0].toUpperCase() + item.slice(1))
    .join(' ');
  useEffect(() => {
    setIsLoading(true);
    setRecent([]);
    setList([]);
    base
      .get('/compensations/snr-marketers-compensation-view/', { params: { snr_marketer_id, package: type } })
      .then(({ data }) => {
        if (!data.length) {
          toast.warn('No subscriptions found');

          return;
        }
        const newData = data
          .filter((item) => !!item.subscription && !!item?.agent)
          .map((item) => ({
            id: item.id,
            name: `${item.agent.user.first_name} ${item.agent.user.last_name}`,
            email: item.agent.user.email,
            date: item.subscription.current_period_start,
            marketer: `${item.marketer.user.first_name} ${item.marketer.user.last_name}`,
            package: item.package.split('-').join(' '),
          }));
        // filter items that are within 7 days of today
        setList(newData);
        const recent = newData.filter((item) => {
          const today = new Date();
          const date = new Date(item.date);
          const diff = Math.abs(today - date);
          const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
          return days <= 7;
        });
        setRecent(recent);
      })
      .catch((err) => {
        toast.error('Could not get data');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [snr_marketer_id, type]);

  const handleClick = (item) => {
    setSelectedSub(item);

    setDetailsModalOpen(true);
  };

  if (!allowed.includes(type)) {
    return <Navigate to="/404" replace state={{ from: '/dashboard' }} />;
  }

  return (
    <>
      {isLoading && <Spinner />}
      <Modal open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)}>
        <div className="mod2" style={{ maxWidth: '70vw' }}>
          <div className="mod2header">
            <div>
              <p style={{ textTransform: 'capitalize' }}>{selectedSub?.package}</p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModalOpen(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="bigg">
            <div>
              <p>
                Agent's Name: <b>{selectedSub?.name}</b>
              </p>

              <p>
                Agent's Email: <b>{selectedSub?.email}</b>
              </p>
              <p>
                Marketer: <b>{selectedSub?.marketer}</b>
              </p>
            </div>
            <div>
              <p>
                Subscription: <b style={{ textTransform: 'capitalize' }}>{selectedSub?.package}</b>
              </p>
              <p>
                Current Start Date: <b>{new Date(selectedSub?.date).toDateString()}</b>
              </p>
            </div>
          </div>
        </div>
      </Modal>
      <div className="subT">
        {/* <form className="modinputs" onSubmit={(e) => e.preventDefault()}>
          <Input placeholder="Enter State" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter County" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter Office Address" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter Office Name" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
              marginRight: '0',
            }}
            text="Filter"
          />
        </form> */}

        <div className="subT_header" style={{ margin: 0 }}>
          <p style={{ marginTop: 0 }}>{title}</p>
        </div>
        <div className="subT_holder">
          {recent.length > 0 && (
            <>
              <p style={{ fontWeight: 700, fontSize: '18px' }}>Recent Subscribers</p>
              {recent.map((item) => (
                <SubscriberRow
                  name={item.name}
                  address={item.email}
                  date={new Date(item.date).toDateString()}
                  key={item.id}
                  onClick={() => handleClick(item)}
                />
              ))}
            </>
          )}

          <p>All</p>
          {list.map((item) => (
            <SubscriberRow
              name={item.name}
              address={item.email}
              date={new Date(item.date).toDateString()}
              key={item.id}
              onClick={() => handleClick(item)}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default SubscriptionType;

function SubscriberRow({
  name = 'Jane Doe',
  address = 'Coldwell Banker -Santa Clara, CA',
  date = 'Feb 16th, 2022',
  onClick,
}) {
  return (
    <div className="checker" onClick={onClick}>
      <Grid container spacing={2}>
        <Grid item xl={4}>
          {name}
        </Grid>
        <Grid item xl={4}>
          {address}
        </Grid>
        <Grid item xl={4}>
          {date}
        </Grid>
      </Grid>
    </div>
  );
}
